import styled, { css } from 'styled-components';

import { Icon, IconName } from '../Icon';
import { Text } from '../Typography/Text';

interface ILegacyStyleProps {
    isClickable?: boolean;
    legacyDesign?: boolean;
}

const ContainerNewStyleOverride = css<ILegacyStyleProps>`
    background: ${({ theme }) => theme.colors.lightShadow};
    border-radius: 0.5rem;
    border: none;
    margin: 0;
    padding: 0.5rem 0.75rem 0.375rem 0.75rem;
    column-gap: 0.5rem;
    cursor: ${({ isClickable }) => (isClickable ? 'pointer' : 'default')};

    &:hover,
    &:focus {
        background: ${({ isClickable, theme }) =>
            isClickable && theme.colors.mediumShadow};
    }

    &:active {
        background: ${({ isClickable, theme }) =>
            isClickable && theme.colors.darkShadow};
    }
`;

const LabelNewStyleOverride = css`
    font-size: ${({ theme }) => theme.fontSizes[4]};
    line-height: 1.4285714286;
    color: ${({ theme }) => theme.colors.fontPrimary};
`;

const IconNewStyleOverride = css`
    background: none;
    padding: 0;
    border-radius: 0;
    border: none;
    width: 0.625rem;
    padding-bottom: 0.125rem;
`;

export const Container = styled.div<ILegacyStyleProps>`
    display: inline-flex;
    flex-direction: row;
    justify-content: space-between;
    column-gap: 1rem;
    align-items: center;
    width: auto;
    background: ${({ theme }) => theme.colors.badge};
    border-radius: 5px;
    padding: 0.5rem;
    z-index: inherit;
    ${({ legacyDesign }) => (legacyDesign ? '' : ContainerNewStyleOverride)}
`;

export const Label = styled(Text)<ILegacyStyleProps>`
    color: ${({ theme }) => theme.colors.badgeFont};
    ${({ legacyDesign }) => (legacyDesign ? '' : LabelNewStyleOverride)}
`;

export const DeleteIcon = styled(Icon).attrs({
    iconName: IconName.CLOSE,
})<ILegacyStyleProps>`
    width: 1rem;
    margin: 0;
    background: white;
    border-radius: 50%;
    padding: 0.25rem;
    ${({ legacyDesign }) => (legacyDesign ? '' : IconNewStyleOverride)}
`;
